// extracted by mini-css-extract-plugin
export default {"wrapper":"UsersSearchBar_wrapper__b5n3H","input":"UsersSearchBar_input__6zY5m"};